import type { FunctionComponent } from 'react';
import type { LinkAsButtonVariant } from '@property.com.au/ui-kit';
import { OutboundLink } from '../../../../../app-kit/components/OutboundLink/OutboundLink';

interface SchoolOutboundLink {
  title: string;
  url: string;
  variant: LinkAsButtonVariant;
  rel?: string;
}

export const SchoolOutboundLink: FunctionComponent<SchoolOutboundLink> = ({
  title,
  url,
  variant,
  rel,
}) => {
  return (
    <OutboundLink
      href={url}
      outboundLinkType="school-website-outbound-link"
      title={title}
      variant={variant}
      sizeVariant="medium"
      rel={rel}
    >
      {title}
    </OutboundLink>
  );
};
